var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarnedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3cdf16;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2234",
    "data-name": "Group 2234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5534",
    "data-name": "Path 5534",
    className: "cls-1",
    d: "M1,8.1,7,.9l6,7.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnedArrow);
export default __webpack_public_path__ + "static/media/earned-arrow.43ec1e14ed47172b70d7347b41089f03.svg";
export { ForwardRef as ReactComponent };